<h4 class="mb-4">Predefined SMS</h4>
<div class="row">
	<div class="col-12">
		<mat-progress-bar mode="indeterminate" *ngIf="(loadingPredefinedSms$ | async)"></mat-progress-bar>
		<div *ngIf="!(loadingPredefinedSms$ | async) &&!(hasPredefinedSMSes$ | async)">No predefined SMS!</div>
		<div *ngIf="!(loadingPredefinedSms$ | async) && (hasPredefinedSMSes$ | async)" class="table-responsive">
			<table class="table">
				<thead>
				<tr>
					<th scope="col">Message</th>
					<th scope="col" class="text-center">Actions</th>
				</tr>
				</thead>
				<tbody>
				<ng-container *ngFor="let pSMS of predefinedSMSes$ | async">
					<ng-container [ngTemplateOutlet]="StreamItemTemplate" [ngTemplateOutletContext]="{item: pSMS}"></ng-container>
				</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</div>
<div class="row mb-2 no-gutters mt-3">
	<div class="col-6">
    	<button mat-button class="float-left mr-2" (click)="onCloseClick()" color="primary" disabled>Add</button>
  	</div>
	<div class="col-6">
		<button mat-button class="float-right mr-2" (click)="onCloseClick()" color="warn">Cancel</button>
	</div>
</div>

<ng-template #StreamItemTemplate let-item="item">
	<tr>
		<td class="table-row sms-column" (click)="onSelect(item.body)">{{item.body | maxCharacters: 300}}</td>
		<td nowrap class="table-row text-center">
			<button mat-icon-button color="primary" disabled>
				<mat-icon aria-label="More information">edit</mat-icon>
			</button>
			<button mat-icon-button color="warn" disabled>
				<mat-icon aria-label="More information">delete</mat-icon>
			</button>
		</td>
	</tr>
</ng-template>